export default __webpack_public_path__ + "static/media/team-4.4e915ff4.jpg";